const formikConfig = () => {
  return {
    initialValues: {
      'portrait-release-agreement-checkbox': false,
    },

    enableReinitialize: true,
  }
}

export default formikConfig
